<template>
  <div class="container py-4">
    <div class="card shadow-sm p-4">
      <!-- Título sin margen-top extra -->
      <h3 class="text-center mb-4">Habitaciones Pendientes de Supervisión</h3>

      <div v-if="habitaciones.length === 0" class="text-center text-muted">
        No hay habitaciones pendientes de supervisión.
      </div>

      <div v-for="hab in habitaciones" :key="hab.IdReservaHabitacion" class="card mb-3 shadow-sm">
        <div class="card-body">
          <h5 class="card-title">Habitación: {{ hab.reservacion?.habitacion?.Numero || 'N/A' }}</h5>

          <!-- Evaluaciones de Calidad -->
          <div class="row mb-3">
            <!-- Limpieza -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold">Limpieza General</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'limpieza_' + hab.IdReservaHabitacion"
                         :id="'limpieza_bueno_' + hab.IdReservaHabitacion" value="bueno" v-model="hab.calidadLimpieza">
                  <label class="form-check-label" :for="'limpieza_bueno_' + hab.IdReservaHabitacion">
                    ✅ Bueno
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'limpieza_' + hab.IdReservaHabitacion"
                         :id="'limpieza_malo_' + hab.IdReservaHabitacion" value="malo" v-model="hab.calidadLimpieza">
                  <label class="form-check-label" :for="'limpieza_malo_' + hab.IdReservaHabitacion">
                    ❌ Malo
                  </label>
                </div>
              </div>
            </div>

            <!-- Papel -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold">Papel Higiénico</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'papel_' + hab.IdReservaHabitacion"
                         :id="'papel_bueno_' + hab.IdReservaHabitacion" value="bueno" v-model="hab.calidadPapel">
                  <label class="form-check-label" :for="'papel_bueno_' + hab.IdReservaHabitacion">
                    ✅ Bueno
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'papel_' + hab.IdReservaHabitacion"
                         :id="'papel_malo_' + hab.IdReservaHabitacion" value="malo" v-model="hab.calidadPapel">
                  <label class="form-check-label" :for="'papel_malo_' + hab.IdReservaHabitacion">
                    ❌ Malo
                  </label>
                </div>
              </div>
            </div>

            <!-- Ducha -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold">Ducha/Baño</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'ducha_' + hab.IdReservaHabitacion"
                         :id="'ducha_bueno_' + hab.IdReservaHabitacion" value="bueno" v-model="hab.calidadDucha">
                  <label class="form-check-label" :for="'ducha_bueno_' + hab.IdReservaHabitacion">
                    ✅ Bueno
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'ducha_' + hab.IdReservaHabitacion"
                         :id="'ducha_malo_' + hab.IdReservaHabitacion" value="malo" v-model="hab.calidadDucha">
                  <label class="form-check-label" :for="'ducha_malo_' + hab.IdReservaHabitacion">
                    ❌ Malo
                  </label>
                </div>
              </div>
            </div>

            <!-- Cama -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold">Cama/Ropa de Cama</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'cama_' + hab.IdReservaHabitacion"
                         :id="'cama_bueno_' + hab.IdReservaHabitacion" value="bueno" v-model="hab.calidadCama">
                  <label class="form-check-label" :for="'cama_bueno_' + hab.IdReservaHabitacion">
                    ✅ Bueno
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'cama_' + hab.IdReservaHabitacion"
                         :id="'cama_malo_' + hab.IdReservaHabitacion" value="malo" v-model="hab.calidadCama">
                  <label class="form-check-label" :for="'cama_malo_' + hab.IdReservaHabitacion">
                    ❌ Malo
                  </label>
                </div>
              </div>
            </div>

            <!-- Otros -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold">Otros Aspectos</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'otros_' + hab.IdReservaHabitacion"
                         :id="'otros_bueno_' + hab.IdReservaHabitacion" value="bueno" v-model="hab.calidadOtros">
                  <label class="form-check-label" :for="'otros_bueno_' + hab.IdReservaHabitacion">
                    ✅ Bueno
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" :name="'otros_' + hab.IdReservaHabitacion"
                         :id="'otros_malo_' + hab.IdReservaHabitacion" value="malo" v-model="hab.calidadOtros">
                  <label class="form-check-label" :for="'otros_malo_' + hab.IdReservaHabitacion">
                    ❌ Malo
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Observaciones -->
          <div class="mb-3">
            <label class="form-label fw-bold">Observaciones Adicionales</label>
            <textarea v-model="hab.nota" placeholder="Escribe observaciones detalladas..."
                      class="form-control" rows="3"></textarea>
          </div>
          <!-- Opción para regresar a limpieza -->
          <div class="mb-3">
            <div class="form-check p-3 border rounded" :class="hab.regresarALimpieza ? 'bg-warning bg-opacity-10 border-warning' : 'bg-light'">
              <input class="form-check-input" type="checkbox"
                     :id="'regresar_' + hab.IdReservaHabitacion"
                     v-model="hab.regresarALimpieza">
              <label class="form-check-label fw-bold" :for="'regresar_' + hab.IdReservaHabitacion">
                ⚠️ Regresar habitación a limpieza (necesita ser limpiada nuevamente)
              </label>
              <small class="d-block mt-1 text-muted">Marca esta opción si la habitación no cumple con los estándares y debe limpiarse de nuevo.</small>
            </div>
          </div>
          <button class="btn btn-success w-100" @click="supervisar(hab)">✓ Marcar como supervisada</button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
      <div class="toast show text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'SupervisarLimpieza',
  data() {
    return {
      habitaciones: [],
      alerta: { mensaje: '', tipo: 'success' },
      mostrarToast: false
    }
  },
  computed: {
    toastColor() {
      return {
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning text-dark',
        info: 'bg-info text-dark'
      }[this.alerta.tipo] || 'bg-primary'
    },
    iconoToast() {
      return {
        success: 'bi bi-check-circle-fill',
        danger: 'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info: 'bi bi-info-circle-fill'
      }[this.alerta.tipo] || 'bi bi-info-circle-fill'
    }
  },
  mounted() {
    this.cargarHabitaciones();
  },
  methods: {
    async cargarHabitaciones() {
      try {
        const res = await axios.get(`${API_URL}/habitaciones-pendientes-supervision`);
        this.habitaciones = res.data.map(h => ({
          ...h,
          nota: '',
          calidadLimpieza: null,
          calidadPapel: null,
          calidadDucha: null,
          calidadCama: null,
          calidadOtros: null,
          regresarALimpieza: false
        }));
      } catch (err) {
        this.mostrarAlerta('Error al cargar habitaciones', 'danger');
      }
    },
    async supervisar(hab) {
      try {
        const response = await axios.post(`${API_URL}/supervisar-habitacion/${hab.IdReservaHabitacion}`, {
          NotaSupervision: hab.nota,
          CalidadLimpieza: hab.calidadLimpieza,
          CalidadPapel: hab.calidadPapel,
          CalidadDucha: hab.calidadDucha,
          CalidadCama: hab.calidadCama,
          CalidadOtros: hab.calidadOtros,
          RegresarALimpieza: hab.regresarALimpieza
        });

        const tipo = hab.regresarALimpieza ? 'warning' : 'success';
        this.mostrarAlerta(response.data.message, tipo);
        this.cargarHabitaciones();
      } catch (err) {
        this.mostrarAlerta('Error al marcar supervisión', 'danger');
      }
    },
    mostrarAlerta(mensaje, tipo = 'success') {
      this.alerta.mensaje = mensaje;
      this.alerta.tipo = tipo;
      this.mostrarToast = true;
      setTimeout(() => {
        this.mostrarToast = false;
      }, 4000);
    },
    cerrarToast() {
      this.mostrarToast = false;
    }
  }
}
</script>

<style scoped>
textarea {
  resize: vertical;
}

.form-check-input:checked {
  background-color: #198754;
  border-color: #198754;
}

.form-label.fw-bold {
  font-size: 0.9rem;
  color: #495057;
  margin-bottom: 0.5rem;
}

.form-check-label {
  cursor: pointer;
  user-select: none;
}

.card {
  border-left: 4px solid #0d6efd;
}

.card-title {
  color: #0d6efd;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
}

.form-check-input[type="checkbox"] {
  cursor: pointer;
  width: 1.25rem;
  height: 1.25rem;
}

.form-check-label {
  cursor: pointer;
}
</style>
